module.exports = __webpack_public_path__ + "video01.jpg?421a49fba316d2e96bb701e845902a59";


//////////////////
// WEBPACK FOOTER
// ./static/images/video01.jpg
// module id = 12
// module chunks = 10 11